var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"formit-checkbox-wrapper"},[_c('label',{attrs:{"for":_vm.name}},[_c('input',_vm._b({ref:"input",attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.currentValue},on:{"change":_vm.handleChange}},'input',_vm.attributes,false))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528aa6f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-formit-fields/src/components/checkbox/checkbox.vue
// module id = null
// module chunks = 